export default __webpack_public_path__ + "static/media/190629_190332_Stuart & Kennedy.bd94ba38.jpg";